import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { MenuProvider } from './context/MenuContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
root.render(
  <MenuProvider>
        <App />
    </MenuProvider>,
);
